import {HostingDomainZoneData} from "./hostingDomainZoneData";
import * as punycode from "punycode";

export class HostingDomainsZoneDataMapper {
  public static map(zone: any): HostingDomainZoneData {
      const hostingZoneData: HostingDomainZoneData = new HostingDomainZoneData();
      hostingZoneData.id = zone.id;
      hostingZoneData.name = punycode.toUnicode(zone.name);
      hostingZoneData.nameservers = zone.nameservers ? JSON.parse(zone.nameservers) : null;
      hostingZoneData.zoneId = zone.zone_id;
    return hostingZoneData;
  }


}
